module.exports = __webpack_public_path__ + "media/images/weibo-a1c34c55.svg";